import { Autocomplete, Chip, Divider, Grid, TextField, Typography } from '@mui/material'
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyle from "../../../assets/styles/global.module.scss";
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { campaignContact, campaignContactData, campaignContactFieldData, campaignContactTagAssignment, countryCodesInterface, tagDataInterface, updateCampaignContactPayload } from '../../../models/axiosModel';
import GlobalButton from '../../utility/globalButton/button';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { flagAddTagDialogObj } from './contactsGlobal';
import Required from '../../utility/required';
import { getCustomTagOption, getUpdatedFieldData, isGenericTag, isOptOutMetaTag, phoneNumberRegEx, isRequiredContactField, requiredFields } from './contactConstant';
import { CountryCode, parsePhoneNumber } from 'libphonenumber-js/mobile';
import { debounce } from 'lodash';
import RenderCustomOption from '../../global/autocomplete/renderCustomOption';
import { hasContactManageAccess } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { filterAutocompleteOptionsWithException } from '../../../utils/constants';

interface EditContactPopupProps {
    requiredCampaignContact: campaignContact[],
    setFlagEditContactDialog: React.Dispatch<React.SetStateAction<boolean>>,
    editCampaignContactApiCall: (payload: updateCampaignContactPayload) => void,
    getCountryCodeApiCall: () => Promise<void>,
    onClickOfCustomTagOption: (flagEditTagPopup: boolean, flagEditTag: boolean, tag?: tagDataInterface,) => void,
    onClickOfDeleteTag: (tag: tagDataInterface) => void,

    contactFields: campaignContactData[],
    setContactFields: React.Dispatch<React.SetStateAction<campaignContactData[]>>,
    contactTagData: Omit<campaignContactTagAssignment, 'contact_tag_assignment_id'>[],
    setContactTagData: React.Dispatch<React.SetStateAction<Omit<campaignContactTagAssignment, 'contact_tag_assignment_id'>[]>>,

    flagAddTagDialogObj: flagAddTagDialogObj,
    setFlagAddTagDialogObj: React.Dispatch<React.SetStateAction<flagAddTagDialogObj>>,
}

const EditContactPopup: React.FC<EditContactPopupProps> = ({ requiredCampaignContact, setFlagEditContactDialog, editCampaignContactApiCall, contactFields, setContactFields, contactTagData, setContactTagData, flagAddTagDialogObj, setFlagAddTagDialogObj, getCountryCodeApiCall, onClickOfCustomTagOption, onClickOfDeleteTag }) => {

    const { campaignContactTagData, campaignContactFieldData, countryCodeList } = useContext(ContactContext) as ContactContextPayload;
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const maxHeight = window.innerHeight - 230;

    // const [contactFields, setContactFields] = useState<campaignContactData[]>(requiredCampaignContact[0].contact_data);
    // const [contactTagData, setContactTagData] = useState<Omit<campaignContactTagAssignment, 'contact_tag_assignment_id'>[]>(requiredCampaignContact[0].contact_tag_assignment)

    const [flagInValidPhoneNumber, setFlagInValidPhoneNumber] = useState<boolean>(false); 

    const getPhoneNumberValueFromContactField = (contactFields: campaignContactData[]) => {
        return contactFields.find((field) => field.contact_field_name.toLowerCase() == "phone number")?.contact_data_value || "";
    }

    const getCountryCodeValueFromContactField = (contactFields: campaignContactData[]) => {
        return contactFields.find((field) => (field.contact_field_name.toLowerCase() == "country_code" || field.contact_field_name.toLowerCase() == "country code"))?.contact_data_value || "";
    }

    const checkDisableSaveButton = () => {
        if (contactFields.length > 0) {
            
            for(let i = 0; i < requiredFields?.length; ++i){
                const fieldName = requiredFields[i];
                const hasFieldData = contactFields?.some((contactField) => contactField?.contact_field_name?.toLowerCase() === fieldName);
                if(!hasFieldData){
                    return true;
                }
            }

            for(let i = 0; i < contactFields.length; ++i){
                const fieldName = contactFields[i].contact_field_name.toLowerCase();
                if(["phone number", "first name", "country_code", "country code"].includes(fieldName)){
                    if(contactFields[i].contact_data_value.trim().length == 0){
                        return true;
                    }
                }
            }

            // Validate Phone Number
            const phoneNumber = getPhoneNumberValueFromContactField(contactFields);
            const countryCode = getCountryCodeValueFromContactField(contactFields);
            if(countryCode.length > 0 && phoneNumber.length > 0){
                try {
                    const validate = parsePhoneNumber(phoneNumber, countryCode as CountryCode);
                    if(validate.isValid() && validate.country == countryCode && (validate.getType()?.toLowerCase() == "undefined" ||  validate.getType()?.toLowerCase().indexOf('mobile') != -1 )){
                        return false;
                    } else return true;
                } catch (err) {
                    return true;
                }
            }
            return false;
        } else return true;
    }

    const saveButtonClickHandler = () => {
        const contact_data = contactFields.map((field) => {
            if (field.created_at_timestamp == "") {
                return ({
                    contact_field_id: field.contact_data_id,
                    contact_data_id: null,
                    contact_data_value: field.contact_data_value
                })
            }
            return ({
                contact_data_id: field.contact_data_id,
                contact_data_value: field.contact_data_value
            });
        })
        const tag_id_array = contactTagData.map((tag) => {
            return tag.contact_tag_id
        })


        const payload: updateCampaignContactPayload = {
            contact_id: requiredCampaignContact[0].contact_id,
            contact_data: contact_data,
            contact_tag_id: tag_id_array,
        }
        editCampaignContactApiCall(payload);
        setFlagEditContactDialog(false);
    }

    const getSelectedTagOptions = useMemo(() => {
        const allTags = campaignContactTagData[0]?.contact_tag_data ?? [];
        return allTags.length > 0
            ? allTags.filter((tag) => contactTagData.some((tagData) => tag.contact_tag_id === tagData.contact_tag_id))
            : [];
    }, [campaignContactTagData, contactTagData]);

    const mergeWithProtectedOptOutMetaTags = (value: tagDataInterface[]) => {
        const protectedTags = getSelectedTagOptions.filter((tag) => isOptOutMetaTag(tag?.contact_tag_name));
        const valueTagIds = new Set(value.map((tag) => tag.contact_tag_id));
        const missingProtectedTags = protectedTags.filter((tag) => !valueTagIds.has(tag.contact_tag_id));
        return missingProtectedTags.length > 0 ? [...value, ...missingProtectedTags] : value;
    }

    const onChangeOfTag = (value: tagDataInterface[]) => {
        let flag_new_tag = false;
        for (let i = 0; i < value.length; ++i) {
            if (value[i].contact_tag_id === -1 && value[i].contact_tag_name === "New Tag") {
                flag_new_tag = true;
                break;
            }
        }
        if (flag_new_tag) {
            setFlagEditContactDialog(false);
            setFlagAddTagDialogObj((prev: flagAddTagDialogObj) => ({
                flag: true,
                flagFromEditContactDialog: true,
            }))
        } else {
            setContactTagData(mergeWithProtectedOptOutMetaTags(value));
        }
    }

    const handleTagInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== "Backspace" || event.currentTarget.value) {
            return;
        }

        const lastSelectedTag = getSelectedTagOptions[getSelectedTagOptions.length - 1];
        if (lastSelectedTag && isOptOutMetaTag(lastSelectedTag?.contact_tag_name)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    const handleValidatePhoneNumber = (phoneNumber: string, countryCode: string) => {
        try {
            const validate = parsePhoneNumber(phoneNumber, countryCode as CountryCode);
            if(!validate.isValid() || validate.country != countryCode || !(validate.getType()?.toLowerCase() == "undefined" ||  validate.getType()?.toLowerCase().indexOf('mobile') != -1 )){
                setFlagInValidPhoneNumber(true);
            } else {
                setFlagInValidPhoneNumber(false);
            }
        } catch (err) {
            setFlagInValidPhoneNumber(true);
        }
    }

    const onBlurOfPhoneNumber = useCallback(
        debounce((phoneNumber: string, countryCode: string) => {
            handleValidatePhoneNumber(phoneNumber, countryCode);
        }, 1200), []
    );

    const onChangeOfTextField = (value: string, data: campaignContactFieldData) => {
        setContactFields((prev) => {
            let updated = false;

            const newFields = prev.map((field) => {
                if (field.contact_field_name === data.contact_field_name) {
                    updated = true;
                    field.contact_data_value = value;
                }
                return field;
            });

            if (!updated) {
                newFields.push({
                    contact_data_id: data.contact_field_id,
                    contact_field_id: data.contact_field_id,
                    contact_field_name: data.contact_field_name,
                    contact_data_value_flag_json: false,
                    contact_data_value: value,
                    flag_default: false,
                    created_at_timestamp: "",
                    updated_at_timestamp: null,
                })
            }
            return newFields;
        });

        if(["phone number", "country_code", "country code"].includes(data.contact_field_name.toLowerCase())){
            const countryCodeValue = getCountryCodeValueFromContactField(contactFields);
            const phoneNumberValue = getPhoneNumberValueFromContactField(contactFields);

            if(countryCodeValue && phoneNumberValue){
                onBlurOfPhoneNumber(phoneNumberValue, countryCodeValue);
            } else {
                setFlagInValidPhoneNumber(false);
            }
        }
    }

    useEffect(() => {
        if(!countryCodeList){
            getCountryCodeApiCall(); // Get Country Code (Generic Call).
        }
    }, [])

    const getCountryCodeValue = (data: campaignContactFieldData) => {
        return countryCodeList?.find((code: countryCodesInterface) => code.country_iso_code == contactFields.find((field) => field.contact_field_name === data.contact_field_name)?.contact_data_value) || null;
    }

    const checkDisableCountryCode = (data: campaignContactFieldData) => {
        const value = getCountryCodeValue(data);
        if(value){
            const savedCountryCode = requiredCampaignContact?.[0]?.contact_data?.find((field: campaignContactData) => field?.contact_field_name?.toLowerCase() === 'country_code' || field?.contact_field_name?.toLowerCase() === 'country code');
            if(savedCountryCode){
                if(savedCountryCode?.contact_data_value?.length > 0){
                    return true;
                }
            }
        }
        return false;
    }

    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={style.popupTitleTypography}>Edit Contact</Typography>
                    </Grid>

                    <Divider className={style.popupTitleDivider} />

                    <Grid item sx={{ maxHeight: `${maxHeight}px`, overflow: 'auto' }}>
                        <Grid container className={style.popupBodyContainer} spacing={2}>
                            {/* {requiredCampaignContact[0]?.contact_data?.map((data: campaignContactData, ind: number) => { */}
                            {/* {campaignContactFieldData?.contact_field_data?.sort((a, b) => a.contact_field_id - b.contact_field_id)?.map((data: campaignContactFieldData, ind: number) => { */}
                            {getUpdatedFieldData(campaignContactFieldData?.contact_field_data)?.map((data: campaignContactFieldData, ind: number) => {
                                return (
                                    <Grid key={ind} item lg={6} xs={12}>
                                        <Grid container direction={"column"} gap={"10px"}>
                                            <Grid item xs={12}>
                                                <Grid container gap="5px">
                                                    <Typography className={style.popupFieldTypography}>{data.contact_field_name} {isRequiredContactField(data?.contact_field_name) && <Required />}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {(data.contact_field_name.toLowerCase() == "country_code" || data.contact_field_name.toLowerCase() == "country code") ?
                                                    <>
                                                        <Autocomplete
                                                            className={`${style.contactFilterDropdownsInPopup}`}
                                                            options={countryCodeList || []}
                                                            getOptionLabel={(option) => `${option.country_name} (+${option.country_code})`}
                                                            value={getCountryCodeValue(data)}
                                                            onChange={(_: React.SyntheticEvent, value: countryCodesInterface | null) => onChangeOfTextField(value ? value.country_iso_code : "", data)}
                                                            renderInput={(params) => <TextField {...params} placeholder='Select Country Code' />}
                                                            disabled={checkDisableCountryCode(data)}
                                                        />
                                                        {flagInValidPhoneNumber && <span className={style.inValidPhoneNumberSpan}>Please Enter Valid Country Code</span>} 
                                                    </>
                                                    :
                                                    <>
                                                        <TextField
                                                            value={contactFields.find((field) => field.contact_field_name === data.contact_field_name)?.contact_data_value || ""}
                                                            onChange={(e) => { 
                                                                if(data.contact_field_name.toLowerCase() == "phone number"){
                                                                    if(phoneNumberRegEx.test(e.target.value)){
                                                                        onChangeOfTextField(e.target.value, data) 
                                                                    }
                                                                } else {
                                                                    onChangeOfTextField(e.target.value, data)
                                                                }
                                                            }}
                                                            className={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth}`}
                                                            disabled={data.contact_field_name.toLowerCase() == "phone number"}
                                                            placeholder={`Add ${data.contact_field_name}`}
                                                        />
                                                    </>
                                                }   
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                );
                            })}

                            <Grid item xs={12}>
                                <Grid container direction={"column"} gap={"10px"}>
                                    <Grid item xs={12}>
                                        <Typography className={style.popupFieldTypography}>Tag </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            className={`${style.contactFilterDropdownsInPopup}`}
                                            options={(campaignContactTagData[0].contact_tag_data) ? [...(campaignContactTagData[0].contact_tag_data), ...(getCustomTagOption(apiRoutesPermissionAssignment, userDetail))] : []}
                                            getOptionLabel={(option) => option.contact_tag_name || ''}
                                            filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "contact_tag_name", "contact_tag_id")}
                                            multiple
                                            value={getSelectedTagOptions}
                                            onChange={(_: React.SyntheticEvent, value: tagDataInterface[]) => { onChangeOfTag(value); }}
                                            ListboxProps={{ className: style.singleContactListbox }}
                                            getOptionDisabled={(option) => isOptOutMetaTag(option?.contact_tag_name)}
                                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: tagDataInterface) => {
                                                return (
                                                    <RenderCustomOption 
                                                        autocompleteRenderOptionProps={props} 
                                                        option={option} 
                                                        customOptionName={"New Tag"}
                                                        optionName={option['contact_tag_name']}
                                                        optionLabelKey={'contact_tag_id'}
                                                        onClickOfCustomOption={() => onClickOfCustomTagOption(true, false)}
                                                        flagShowEditOptionIcon={hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isGenericTag(option?.contact_list_id)}
                                                        onClickOfEditOption={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, option: tagDataInterface) => {e.stopPropagation(); onClickOfCustomTagOption(true, true, option)}}
                                                        flagShowDeleteOptionIcon={hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isGenericTag(option?.contact_list_id)}
                                                        onClickOfDeleteOption={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, option: tagDataInterface) => { e.stopPropagation(); onClickOfDeleteTag(option) }}
                                                    />
                                                );
                                            }}
                                            renderInput={params => {
                                                const { InputProps, ...restParams } = params;
                                                const { startAdornment, ...restInputProps } = InputProps;
                                                return (
                                                    <TextField
                                                        {...restParams}
                                                        placeholder='Select Tags'
                                                        onKeyDown={handleTagInputKeyDown}
                                                        InputProps={{
                                                            ...restInputProps,
                                                            startAdornment: (
                                                                <div className={style.selectTagTextField}>
                                                                    {startAdornment}
                                                                </div>
                                                            ),
                                                        }}
                                                    />
                                                );
                                            }}
                                            renderTags={(value, getTagProps) => 
                                                value.map((option, index) => {
                                                    const { key, ...tagProps } = getTagProps({ index });
                                                    const { onDelete, ...chipProps } = tagProps;
                                                    const isTagDisable = isOptOutMetaTag(option?.contact_tag_name);

                                                    return <Chip
                                                        key={key}
                                                        {...chipProps}
                                                        label={option?.contact_tag_name ?? ''}
                                                        onDelete={isTagDisable ? undefined : onDelete}
                                                    />
                                                })
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <Grid container justifyContent={"Center"} alignItems={"Center"} gap={"12px"} padding={"20px 0 25px"}>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Cancel"
                                    className="borderedButtonStyle"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    onClick={() => { setFlagEditContactDialog(false); }}
                                />
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Save"
                                    className='primaryButtonStyle'
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    disabled={checkDisableSaveButton()}
                                    onClick={() => { saveButtonClickHandler() }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default EditContactPopup
